import Vue from 'vue';
import alert from '@/components/Modal/ModalAlert.vue';

const Alert = Vue.extend(alert);

const alertFun = function (options) {
  const isString = typeof options === 'string' || typeof options === 'number';
  const Instance = new Alert({
    data: {
      message: isString ? options : options.message || 'message',
      messageClass: (options && options.messageClass) || '',
      subMessage: (options && options.subMessage) || '',
      subClass: (options && options.subClass) || '',
      confirmText: (options && options.confirm) || '確定',
      confirmClass: (options && options.confirmClass) || '',
      confirmIcon: (options && options.confirmIcon) || '',
      cancelText: options && options.cancel,
      hasClose: options && options.hasClose,
      variant: options && options.variant,
      list: options && options.list,
      img: options && options.img,
      vertical: options && options.vertical,
    },
  });
  if (options && options.slot) {
    Instance.$slots.main = options.slot;
  }
  const vm = Instance.$mount();
  document.body.appendChild(vm.$el);
  return vm.init();
};

export default alertFun;
